<div
  class="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4"
>
  <div class="w-full max-w-md p-8 bg-white rounded-xl shadow-lg">
    <button
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>

    <div class="text-center mb-6">
      <i [class]="icono_rol" class="text-6xl text-blue-500 mb-3"></i>
      <h1 class="text-3xl font-bold text-gray-800">Login - {{ nombre_rol }}</h1>
    </div>

    <form (ngSubmit)="onLoginSubmit()" class="space-y-5">
      <div>
        <label
          for="tipo_documento"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Tipo de Documento</label
        >
        <select
          id="tipo_documento"
          name="tipo_documento"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-200"
          [(ngModel)]="tipo_documento"
          required
        >
          <option value="" disabled selected>Seleccione un tipo...</option>
          <option value="DNI">DNI</option>
          <option value="OTRO">Otro Documento</option>
        </select>
      </div>

      <div>
        <label
          for="usuario"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Código/Número de Documento</label
        >
        <input
          type="text"
          id="usuario"
          name="usuario"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-200"
          [(ngModel)]="codigo_documento"
          required
        />
      </div>

      <div>
        <label
          for="password"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Contraseña</label
        >
        <input
          type="password"
          id="password"
          name="password"
          class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition duration-200"
          [(ngModel)]="clave"
          required
        />
      </div>

      <div class="pt-2">
        <button
          type="submit"
          class="w-full py-3 px-4 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg shadow-md transition duration-200 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75"
        >
          Ingresar
        </button>
      </div>
    </form>
  </div>
</div>
